/**
 * One reading of a timestamp, for the whole app.
 *
 * SQLite writes `2026-08-28 09:14:02` with no zone; the server and the client
 * also produce ISO strings ending in Z. `new Date()` reads the first as LOCAL
 * time, so the same message showed one hour out depending on which of the two
 * formats reached which screen. The helper that fixed it lived inside
 * Dashboard and was threaded to three components as a prop, which meant
 * anything not given the prop quietly parsed dates the wrong way.
 */
export function utc(d) {
  if (!d) return new Date();
  if (d instanceof Date) return d;
  const s = String(d);
  if (s.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  return new Date(s.replace(' ', 'T') + 'Z');
}

const RU = 'ru-RU';

export const fmtTime = (d) => utc(d).toLocaleTimeString(RU, { hour: '2-digit', minute: '2-digit' });
export const fmtDate = (d) => utc(d).toLocaleString(RU, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

/** Presence line under a name. Wording unchanged from the original helper. */
export function formatLastSeen(lastSeen) {
  if (!lastSeen) return '';
  const diff = Date.now() - utc(lastSeen).getTime();
  if (diff < 5 * 60 * 1000) return 'онлайн';
  if (diff < 60 * 60 * 1000) return `был(а) ${Math.floor(diff / 60000)} мин. назад`;
  if (diff < 24 * 60 * 60 * 1000) return `был(а) ${Math.floor(diff / 3600000)} ч. назад`;
  return `был(а) ${utc(lastSeen).toLocaleDateString(RU, { day: 'numeric', month: 'short' })}`;
}

/** Call duration, mm:ss, or a dash when there was none. */
export const fmtDur = (s) => (s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : '—');
